/**
 * Payment flow state — Zustand store.
 * State machine for the payment process.
 */
import { create } from 'zustand'
import type { PaymentStep } from '../types/payment.types'

interface PaymentStoreState {
  // State machine
  step: PaymentStep
  selectedMethodId: string | null
  rentalId: string | null
  amountCents: number | null
  currency: string
  error: string | null

  // Actions
  setMethod: (methodId: string) => void
  setRental: (rentalId: string, amountCents: number, currency?: string) => void
  setStep: (step: PaymentStep) => void
  setError: (error: string | null) => void
  reset: () => void
}

const initialState = {
  step: 'idle' as PaymentStep,
  selectedMethodId: null,
  rentalId: null,
  amountCents: null,
  currency: 'USD',
  error: null,
}

export const usePaymentStore = create<PaymentStoreState>((set) => ({
  ...initialState,

  setMethod: (selectedMethodId) => set({ selectedMethodId, step: 'selecting_method', error: null }),

  setRental: (rentalId, amountCents, currency = 'USD') => set({ rentalId, amountCents, currency }),

  setStep: (step) => set({ step }),

  setError: (error) => set({ error, step: error ? 'failed' : 'idle' }),

  reset: () => set(initialState),
}))
